export default "__VITE_ASSET__DRLD$qNl__"